export interface AfterHours {
  id: string;
  organizationId: string;
  buildingId: string;
  spaceId: string;
  year: number;
  month: number;
  hoursRequested: number;
  hoursBilled: number;
  billingRate: number;
  revenue: number;
  notes?: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
